import { useCastle } from "../api/castle";
import { Loading } from "./Loading";
import { ResourceBar } from "../components/ResourceBar";
import { ScreenBanner } from "../components/ScreenBanner";
import { QuestsView } from "../components/QuestsView";

// Top-level "Задания" tab, sibling to Castle / Army / Profile / Marches in
// BottomNav. Wraps the shared QuestsView with banner + resource bar so it
// matches the styling of the other top-level screens.
export function QuestsScreen() {
  const castle = useCastle();

  if (castle.isPending) {
    return <Loading message="Открываю свиток заданий..." />;
  }
  const data = castle.data!;

  return (
    <div className="flex h-full flex-col">
      <ScreenBanner kind="profile" title="Задания" />
      <ResourceBar resources={data.state.resources} safeStorage={data.safeStorage} />
      <div className="mt-2 flex-1 overflow-y-auto">
        <QuestsView enabled />
      </div>
    </div>
  );
}
